var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 21V21C18.895 21 18 20.105 18 19V5C18 3.895 18.895 3 20 3V3C21.105 3 22 3.895 22 5V19C22 20.105 21.105 21 20 21Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21V21C2.895 21 2 20.105 2 19V10.684C2 9.57896 2.895 8.68396 4 8.68396V8.68396C5.105 8.68396 6 9.57896 6 10.684V19C6 20.105 5.105 21 4 21Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21V21C10.895 21 10 20.105 10 19V16.368C10 15.263 10.895 14.368 12 14.368V14.368C13.105 14.368 14 15.263 14 16.368V19C14 20.105 13.105 21 12 21Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsIcon);
export default __webpack_public_path__ + "static/media/statisticsIcon.256f794d58c993f21bb7c8a890f7a45d.svg";
export { ForwardRef as ReactComponent };